import GenerationSection from './GenerationSection'

export default GenerationSection
